import './_collection-trending-articles.scss';
import component from './collection-trending-articles';

export default component;
